export default {
  SET_MUNICIPALITIES: (state, payload) => {
    state.municipalities = payload.data;
  },
};
